import { Injectable } from '@angular/core';
import { parametrosRepository } from './parametros.repository';
import { Observable, catchError, map, of } from 'rxjs';
import { ListarUbigeosPeruRequest, ObtenerParametrosRequest, ParametroRequest, ParametrosNSRequest, listarEntidadesRequest, listarPuertosRequest } from '../domain/parametros.request';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { ObtenerParametrosResponse, ParametroResponse, ParametrosNSResponse } from '../domain/parametros.response';

@Injectable({
  providedIn: 'root'
})
export class ParametrosService extends parametrosRepository {

  constructor(
    private readonly http: HttpClient,
    private readonly parametros: parametrosRepository
  ) {
    super();
  }

  override listarPuertos(request: listarPuertosRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/parametros/getPuertos`, request)
  }

  override listarEntidades(request: listarEntidadesRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/parametros/getEntidades`, request)
  }

  override ListarServicios(): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/parametros/getServicios`, null)
  }

  override ObtenerParametros(request: ObtenerParametrosRequest): Observable<ObtenerParametrosResponse> {
    return this.http.post<ObtenerParametrosResponse>(`${environment.PATH_API}/parametros/getParameters`, request)
  }

  override ListarUbigeosPeru(request: ListarUbigeosPeruRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/parametros/getUbigeosPeru`, request)

  }
  override ObtenerParametrosValor(request: ParametroRequest): Observable<ParametroResponse> {
    return this.http.post<ParametroResponse>(`${environment.PATH_API}/parametros/ObtenerParametrosValor`, request)

  }
  override getTblParametros(request: ParametrosNSRequest): Observable<ParametrosNSResponse> {
    return this.http.post<ParametrosNSResponse>(`${environment.PATH_API}/generales/getConsultarParametros`, request)

  }

}
